import AudiogramDestinationModal from './AudiogramDestinationModal';

export { VideoTypesModalContentsProps } from './VideoTypesModalContents';
export { ChooseDestinationModalContentsProps } from './ChooseDestinationModalContents';

export default AudiogramDestinationModal;
